import React, { Fragment, ReactNode } from 'react';
import FooterContainer from '../containers/FooterContainer';
import HeaderContainer from '../containers/HeaderContainer';
import HeaderContainerMobile from '../containers/HeaderContainerMobile';
import {
  withBreakpoints,
  WithBreakpointsProps
} from '../provider/BreakpointProvider/withBreakpoints';

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout = ({
  children,
  breakpoints
}: MainLayoutProps & WithBreakpointsProps) => {
  // return large layout
  if (breakpoints.large) {
    return (
      <Fragment>
        <HeaderContainer />
        {children}
        <FooterContainer />
      </Fragment>
    );
  }
  // return medium and small layout
  return (
    <Fragment>
      <HeaderContainerMobile />
      {children}
      <FooterContainer />
    </Fragment>
  );
};

export default withBreakpoints(MainLayout);
